import { GitHubIcon, MediumIcon, LinkedInIcon, InstagramIcon } from './components/Icons';

export const profile = {
  name: 'Mathursan',
  role: 'Software Engineer',
  location: 'Singapore',
  tagline:
    '4+ years of experience working with large-scale enterprise systems. Full-stack with a Java backend core, React frontend, and hands-on cloud depth across AWS and GCP.Exposure to handling FinTech systems in on-premise environment',
  email: 'mathursan99@gmail.com',
  phonePrimary: '+94 76 777 4118',
  phoneSecondary: '+65 876 23330',
  linkedin: 'https://linkedin.com/in/mathursan-balathas',
  linkedinLabel: 'linkedin.com/in/mathursan-balathas',
};

export const socialLinks = [
    {
      id: 1,
      icon: GitHubIcon,
      label: 'GitHub',
      url: 'https://github.com/mathursan-001',
    },
    {
      id: 2,
      icon: MediumIcon,
      label: 'Medium',
      url: 'https://medium.com/@mathursanb',
    },
    {
      id: 3,
      icon: LinkedInIcon,
      label: 'LinkedIn',
      url: 'https://linkedin.com/in/mathursan-balathas',
    },
    {
      id: 4,
      icon: InstagramIcon,
      label: 'Instagram',
      url: 'https://instagram.com/mathursan_01',
    },
];

export const highlights = [
  { highlight: '4+', label: 'Years of experience' },
  { highlight: 'Domain Experience', label: 'Food Industry - Supply Chain,Master Data Management,Fintech' },
];

export const skillGroups = [
  { title: 'Languages', tags: ['Java', 'JavaScript', 'Python'] },
  {
    title: 'Backend',
    tags: ['Spring Boot', 'Spring Batch', 'Express.js', 'REST', 'OAuth 2.0', 'Apache Kafka', 'Apache Camel'],
  },
  { title: 'Frontend', tags: ['React', 'Redux', 'RTK'] },
  {
    title: 'Cloud & DevOps',
    tags: ['AWS', 'GCP', 'Docker', 'Terraform', 'GitHub Actions', 'Jenkins', 'Datadog', 'Red Hat Linux'],
  },
  { title: 'Databases', tags: ['PostgreSQL', 'OracleDB'] },
  { title: 'Testing', tags: ['JUnit', 'Mockito', 'Jest'] },
];

export const experience = [
    {
    id: 1,
    role: 'Software Engineer',
    company: 'NETS - BCS',
    location: 'Singapore',
    date: 'May 2026 — Present',
    bullets: [
      'Migrated FAST Real Time Service including G3 Back Office from Solaris to Linux in Active-Active mode.',
  ],
  },
  {
    id: 2,
    role: 'Senior Software Engineer',
    company: 'Sysco LABS Sri Lanka',
    location: 'Colombo, Sri Lanka',
    date: 'Sep 2025 — May 2026',
    bullets: [
      'Built Kafka producers in Spring Boot integrated with Apache Camel, processing ~3,000 records with ~400 attributes each in under 2 minutes.',
      'Implemented logging and monitoring with Datadog — log config, metric collection, and alert setup to proactively catch production issues.',
      'Provisioned and managed GCP infrastructure using Terraform. Hands-on with GCP VM instances running Red Hat Linux.',
    ],
  },
  {
    id: 3,
    role: 'Software Engineer',
    company: 'Sysco LABS Sri Lanka',
    location: 'Colombo, Sri Lanka',
    date: 'May 2023 — Aug 2025',
    bullets: [
      'Developed bulk APIs with Spring Batch (Java 17) to process product, vendor, and customer data for downstream consumers.',
      'Designed complex data models spanning ~50 entities and implemented PostgreSQL PL/pgSQL procedures for efficient data ingestion and integrity.',
      'Orchestrated GCP Workflows, Cloud Storage, EventArc, and Cloud Functions to automate MDM data ingestion into the integration platform.',
      'Built a React data entry portal with SSO via Azure AD + Express.js BFF and DynamoDB DAX for session caching.',
      'Developed a Spring Boot REST service with OAuth 2.0 auth, robust exception handling, and security best practices.',
      'Hands-on with S3, ECS, ALB, Lambda, Route 53, and CloudFront. Provisioned AWS infrastructure with Terraform.',
    ],
  },
  {
    id: 4,
    role: 'Associate Software Engineer',
    company: 'Sysco LABS Sri Lanka',
    location: 'Colombo, Sri Lanka',
    date: 'Aug 2022 — May 2023',
    bullets: [
      'Built a Spring Boot middleware app calculating driver performance metrics with file-based CSV processing and complex calculations.',
      'Developed a React dashboard with Redux Toolkit for performance metrics visualisation.',
      'Implemented S3 lifecycle policies for cloud cost optimisation. Built a serverless AWS Batch pipeline processing ~100K records per run with SES notifications.',
    ],
  },
  {
    id: 5,
    role: 'Software Engineering Intern',
    company: 'Sysco LABS Sri Lanka',
    location: 'Colombo, Sri Lanka',
    date: 'Aug 2021 — Aug 2022',
    bullets: [
      'Gained foundational experience in enterprise Java development, cloud services, and agile engineering practices at Sysco LABS.',
    ],
  },
];

export const projects = [
  {
    id: 1,
    title: 'Invoice Ingestion & Processing System',
    desc: 'A robust system for ingesting and processing invoices at scale.',
    repo:'https://github.com/Mathursan-001/invoice-processing-service',
    tags: ['Spring Boot', 'Spring Batch', 'AWS', 'PostgreSQL', 'Java 17'],
  }
];

export const certifications = [
  {
    id: 1,
    icon: { src: '/icons/aws-svgrepo-com.svg', alt: 'AWS', title: 'AWS' ,size:24},
    title: 'AWS Certified Solutions Architect — Associate',
    date: 'Nov 2025',
  },
];

export const education = [
  {
    id: 1,
    degree: 'BSc (Hons) in Information Technology Specializing in Software Engineering',
    institution: 'Sri Lanka Institute of Information Technology (SLIIT)',
    location: 'Malabe, Sri Lanka',
    date: '2023',
    gpa:3.69,
    class: 'Second Class Honours (Upper Division)',
    details: [,
      "Recipient of the Dean’s List Award on four occasions for displaying academic excellence.",
      "Represented SLIIT in NBQSA (Round 1) as one of the top 25 selected teams - 2022."
    ],
  },
];
